// Definimos la URL base según la variable de entorno, con fallback a localhost
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchZonas = async ({ limit, offset, query }) => {
  try {
    const response = await fetch(`${API_URL}/zonas/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit, offset, query }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener las zonas');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener las zonas:', error);
    throw error;
  }
};

export const createZona = async (zonaData) => {
  try {
    const response = await fetch(`${API_URL}/zonas/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(zonaData),
    });

    if (!response.ok) {
      throw new Error('Error al crear la zona');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear la zona:', error);
    throw error;
  }
};

export const updateZona = async (id, zonaData) => {
  try {
    const response = await fetch(`${API_URL}/zonas/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, data: zonaData }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar la zona');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar la zona:', error);
    throw error;
  }
};

export const deleteZona = async (id) => {
  try {
    const response = await fetch(`${API_URL}/zonas/delete/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Error al eliminar la zona');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar la zona:', error);
    throw error;
  }
};

export const exportZonas = async ({ query = {}, limit = 10000, page = 1 }) => {
  try {
    const response = await fetch(`${API_URL}/zonas/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error('Error al exportar las zonas');
    }

    const result = await response.json();
    
    // El backend devuelve JSON con estructura { data: [], totalRecords: number }
    // Retornamos los datos para que ExportExcelButton los procese
    return result.data || [];
  } catch (error) {
    console.error('Error al exportar las zonas:', error);
    throw error;
  }
};

export const getZonas = async () => {
  try {
    const response = await fetch(`${API_URL}/zonas/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit: 1000, offset: 1, query: { estado: 'Activo' } }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener las zonas');
    }

    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error('Error al obtener las zonas:', error);
    throw error;
  }
};
